<script>
  import { Button } from "paxray-components-svelte";;
  import {
    CHEVRON_DOWN_ICON,
    EDIT_ICON,
    RESET_ALT_ICON,
    TRASH_ICON,
    ZOOMIN_ICON,
  } from "@utils/icons.js";
  export let small = false;
  export let handleEdit = () => {};
  export let handleDelete = () => {};
  export let handleZoomIn = () => {};
  export let handleRestart = () => {};
  export let handleExpandable = () => {};
  export let disabled = false;
  export let restart = false;
  export let expandable = false;
  export let details = false;
</script>

<div
  style="display: flex; gap: 4px; margin: 8px; justify-content: center; align-items: center;"
  class:disabled={disabled && !restart}
>
  {#if expandable && !restart}
    <Button
      kind="secondary"
      size={small ? "small" : "default"}
      icon={EDIT_ICON}
      on:click={handleEdit}
      {disabled}
    />
    <Button
      kind="secondary"
      size={small ? "small" : "default"}
      icon={TRASH_ICON}
      on:click={handleDelete}
      {disabled}
    />
    <Button
      kind="secondary"
      size={small ? "small" : "default"}
      icon={CHEVRON_DOWN_ICON}
      on:click={handleExpandable}
    />
  {:else if restart}
    <Button
      kind="secondary"
      size={small ? "small" : "default"}
      icon={RESET_ALT_ICON}
      on:click={handleRestart}
    />
  {:else}
    {#if details}
      <Button
        kind="secondary"
        size={small ? "small" : "default"}
        icon={ZOOMIN_ICON}
        on:click={handleZoomIn}
        {disabled}
      />
    {/if}
    <Button
      kind="secondary"
      size={small ? "small" : "default"}
      icon={EDIT_ICON}
      on:click={handleEdit}
      {disabled}
    />
    <Button
      kind="secondary"
      size={small ? "small" : "default"}
      icon={TRASH_ICON}
      on:click={handleDelete}
      {disabled}
    />
  {/if}
</div>

<style>
  .disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .disabled:hover {
    pointer-events: none;
  }
</style>
